export function toIsoWithTimeZone(date: Date) {
  const tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num: number) {
      const norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  );
}

export function getDiffInHours(dateA: Date, dateB: Date) {
  if (!dateA || !dateB) return null;
  const diffInMs = Math.abs(
    (dateA as unknown as number) - (dateB as unknown as number)
  );

  const diffInHours = diffInMs / 1000 / 60 / 60;

  return diffInHours;
}

export function getDiffInMinutes(dateA: Date, dateB: Date) {
  if (!dateA || !dateB) return null;
  const diffInMs = Math.abs(
    (dateA as unknown as number) - (dateB as unknown as number)
  );

  const diffInHours = diffInMs / 1000 / 60;

  return diffInHours;
}
